<template>
  <div id="pubTable">
    <div class="pubTitle" v-if="k == 'target_1'"><i></i>关键性业绩考核指标（占比不得超过50%，关键业绩指标包括主要岗位职责、最多不超过10项）</div>
    <div class="pubTitle" v-if="k == 'target_2'"><i></i>GS工作目标（占比不得超过30%，最多不超过10项）</div>
    <div class="pubTitle" v-if="k == 'target_3'"><i></i>工作能力与态度指标（占比不得超过20%）</div>
    <div class="el-table--border">
      <table cellspacing="0" cellpadding="0" border="0" >
        <colgroup>
          <col name="el-table_1_column_1" width="60">
          <col name="el-table_1_column_2" width="300">
          <col name="el-table_1_column_3">
          <col name="el-table_1_column_4" width="150">
          <col name="el-table_1_column_5">
          <col name="el-table_1_column_6" width="125">
          <col name="el-table_1_column_7" width="115">
          <col name="el-table_1_column_8" width="115">
          <col name="el-table_1_column_9" width="60" v-if="k != 'target_3' && status == 1 && enableModule == 'self_rating'">
        </colgroup>
        <thead>
          <tr>
            <th>序号</th>
            <th>
              <template v-if="k=='target_1'">业绩指标（含指标说明） </template> 
              <template v-else-if="k=='target_2'">GS目标 </template> 
              <template v-else>能力指标 </template> 
              <span 
                class="red" 
                v-if="['target_1','target_2'].includes(k) && enableModule == 'self_rating'"
              ></span></th>
            <th>
              <template v-if="k=='target_1'">考核标准 </template>
              <template v-else-if="k=='target_2'">关键结果（考核标准）</template>
              <template v-else>指标评价</template>
              <span 
                class="red"
                v-if="['target_1','target_2'].includes(k) && enableModule == 'self_rating'"
              ></span></th>
            <th>权重{{k == 'target_2' ? '（比例可调整）' : ''}}
              <span 
                class="red"
                v-if="enableModule == 'self_rating' && ['target_1','target_2'].includes(k)"
              ></span>
            </th>
            <th>月度总结
              <span 
                class="red"
                v-if="enableModule == 'self_rating'"
              ></span>
            </th>
            <th>自评分
              <span 
                class="red"
                v-if="enableModule == 'self_rating'"
              ></span>
            </th>
            <th>上级评分
              <span 
                class="red"
                v-if="enableModule == 'second_rating'"
              ></span>
            </th>
            <th>上上级评分
              <span 
                class="red"
                v-if="enableModule == 'third_rating'"
              ></span>
            </th>
            <th v-if="k != 'target_3' && status == 1 && enableModule == 'self_rating'">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in info" :key="index">
            <!-- 序号 -->
            <td>
              <!-- {{index+1}} -->
              {{item.id.value}}
            </td>
            <!-- 业绩指标 -->
            <td :class="[item.target.warning==1 ? 'error' : '']" @click="changeValue(index,'target')">
              <!-- {{item.target.value}} -->
              <el-input 
                type="textarea" 
                autosize 
                v-model="item.target.value" 
                :readonly="true"
                :placeholder="placeholder"
              >
              </el-input>
            </td>
            <!-- 考核标准 -->
            <td :class="[item.result.warning==1 ? 'error' : '']" @click="changeValue(index,'result')">
              <!-- {{item.result.value}} -->
                <!-- :autosize="{minRows:1,maxRows:5}"  -->
              <el-input 
                type="textarea" 
                :autosize="{maxRows:1000}" 
                v-model="item.result.value" 
                :readonly="true"
                :placeholder="warningPlaceholder"
              >
              </el-input>
            </td>
            <!-- 权重（比例可调整） -->
            <td :class="[item.weight.warning==1 ? 'error' : 'quanzhongtd']">
              <div class="quanzhong">
                <el-input-number 
                  v-model="item.weight.value" 
                  :step="0.5" 
                  :precision='1' 
                  step-strictly 
                  controls-position="right" 
                  :min="0.5" 
                  :max="50" 
                  size="small" 
                  @blur="item.weight.value = item.weight.value == undefined ? 0.5 : item.weight.value"
                  @change="item.weight.value < item.self_rating.value ? item.self_rating.value = item.weight.value : ''"
                  v-if="status == 1 && !item.weight.disable"
                ></el-input-number>
                <span v-else>{{item.weight.value}}</span>
                <span>%</span>
              </div>
            </td>
            <!-- 月度总结 -->
            <td :class="[item.summarize.warning==1 ? 'error' : 'listss']" @click="changeValue(index,'summarize')">
              <!-- {{item.summarize.value}} -->
              <el-input 
                type="textarea" 
                autosize 
                v-model="item.summarize.value" 
                placeholder="请输入月度总结"
                :readonly="true"
              >
              </el-input>
            </td>
            <!-- 自评分 -->
            <td :class="[item.self_rating.warning==1 ? 'error' : '']">
              <el-input-number 
                v-model="item.self_rating.value" 
                :step="0.5" 
                :precision='1' 
                step-strictly 
                controls-position="right" 
                :min="0" 
                :max="Number(item.weight.value)" 
                size="small" 
                v-if="status == 1 && !item.self_rating.disable"
                @blur="item.self_rating.value = item.self_rating.value == undefined ? 0.5 : item.self_rating.value"
                @change="getSelfRatingTotal"
              ></el-input-number>
              <span v-else>{{item.self_rating.value || 0}}</span>
            </td>
            <!-- 直接上级打分 -->
            <td :class="[item.second_rating.warning==1 ? 'error' : '']">
              <el-input-number 
                v-model="item.second_rating.value" 
                :step="0.5" 
                :precision='1' 
                step-strictly 
                controls-position="right" 
                :min="0" 
                :max="Number(item.weight.value)" 
                size="small" 
                v-if="status == 1 && !item.second_rating.disable"
                @blur="item.second_rating.value = item.second_rating.value == undefined ? 0.5 : item.second_rating.value"
                @change="getSecondRatingTotal"
              ></el-input-number>
              <span v-else>{{item.second_rating.value}}</span>
            </td>
            <!-- 上上级复核打分 -->
            <td :class="[item.third_rating.warning==1 ? 'error' : '']">
              <el-input-number 
                v-model="item.third_rating.value" 
                :step="0.5" 
                :precision='1' 
                step-strictly 
                controls-position="right" 
                :min="0" 
                :max="Number(item.weight.value)" 
                size="small" 
                v-if="status == 1 && !item.third_rating.disable"
                @blur="item.third_rating.value = item.third_rating.value == undefined ? 0.5 : item.third_rating.value"
                @change="getThirdRatingTotal"
              ></el-input-number>
              <span v-else>{{item.third_rating.value}}</span>
            </td>
            <!-- 操作 -->
            <td v-if="k != 'target_3' && status == 1 && enableModule == 'self_rating'">
              <img src="@/assets/icon1.png" class="jxDetailIcon" @click="deleteItem(item,index)" v-if="info.length > 1">
            </td>
          </tr>
          <tr>
            <td colspan="5" class="totalFont">总计得分：</td>
            <td class="totalStyle">{{selfRatingTotal || '0'}}</td>
            <td class="totalStyle">{{secondRatingTotal || '0'}}</td>
            <td class="totalStyle">{{thirdRatingTotal || '0'}}</td>
            <td class="totalStyle" v-if="k != 'target_3' && status == 1 && enableModule == 'self_rating'"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div 
      class="addTable" 
      v-if="info && info.length < 10 && k != 'target_3' && status == 1"
    >
    <span v-if="k == 'target_2'" @click="addTable">+ 添加GS目标</span>
      <span v-else @click="addTable" >+ 添加业绩指标</span>
    </div>
    <div class="zzc" v-show="deleteDailog" @click.self="deleteDailog=false">
      <div class="pubDailog">
        <div class="content"><img src="@/assets/icon3.png">该指标删除不可恢复，请谨慎操作！</div>
        <div class="btnBox">
          <div class="btn cancel" @click.self="deleteDailog=false">取消</div>
          <div class="btn delete" @click.self="deleteBtn">删除</div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import { collect } from 'collect.js'
// import inputNumber from '@/views/performance/components/inputNumber'
export default {
  data() {
    return {
      selfRatingTotal: 0, //自评分总分
      secondRatingTotal: 0, //直接上级打分
      thirdRatingTotal: 0, //上上级复核打分
      deleteDailog:false,
      deleteIndex:null,//删除项索引
    }
  },
  components: {
    // inputNumber,
  },
  props: ['info', 'k','status','enableModule'],
  mounted() {
    let that = this
    setTimeout(function(){
      that.getSelfRatingTotal()
      that.getSecondRatingTotal()
      that.getThirdRatingTotal()
    },500)
  },
  watch:{
  },
  computed:{
    placeholder(){
      if(this.k == 'target_1') return '请输入业绩指标'
      if(this.k == 'target_2') return '请输入GS目标'
      return ''
    },
    warningPlaceholder(){
      if(this.k == 'target_1') return '请输入考核标准'
      if(this.k == 'target_2') return '请输入关键结果'
      return ''
    }
  },
  methods: {
    changeValue(index,key){
      // !status == 1 || !!item.target.disable
      if(this.status != 1 || this.info[index][key].disable == 1) return
      this.$emit('updateValue',{target:this.k,index:index,key:key})
    },
    getVal(newVal) {
      console.log('newVal', newVal)
    },
    // 删除项
    deleteItem(item, index) {
      this.deleteDailog = true
      this.deleteIndex = index
    },
    deleteBtn(){
      this.$emit('deleteItem', { key: this.k, index: this.deleteIndex })
      this.getSelfRatingTotal()
      this.getSecondRatingTotal()
      this.getThirdRatingTotal()
      this.deleteDailog = false
      this.deleteIndex = null
      // this.pageInfo.splice(index,1)
    },
    // 添加项
    addTable() {
      let collection = collect(this.info)
      let total = collection.sum(product => Number(product.weight.value));
      let item = {
        target_1:50,
        target_2:30,
        target_3:20,
      }
      if(total >= item[this.k]){
        this.$message.error('现有权重超出总权重，请修改后再添加哦~');
        return
      }
      if (this.info.length < 10) {
        this.$emit('addItem')
        this.getSelfRatingTotal()
        this.getSecondRatingTotal()
        this.getThirdRatingTotal()
        // let result = this.info.slice(this.info.length-1,this.info.length)
        // this.info = [...this.info,...result]
        return
      }
      
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      // console.log('columns',columns,'data',data);
      columns.forEach((column, index) => {
        // console.log('column',column,'index',index);
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        // const values = data.map(item => {
        //   if(item[column.property] != undefined){
        //     console.log('-------',item[column.property].value);
        //     Number(item[column.property].value)
        //   }
        // });
        const values = data.map((item) => Number(item[column.property].value))
        console.log('values', values)
      })
      return sums
    },
    // 自评分总分
    getSelfRatingTotal() {
      let that = this
      setTimeout(function(){
        let collection = collect(that.info)
        that.selfRatingTotal = collection.sum(product => Number(product.self_rating.value));
      },500)
    },
    // 直接上级打分总分
    getSecondRatingTotal() {
      let that = this
      setTimeout(function(){
        let collection = collect(that.info)
        that.secondRatingTotal = collection.sum(product => Number(product.second_rating.value));
      },500)
    },
    // 上上级复核打分总分
    getThirdRatingTotal() {
      let that = this
      setTimeout(function(){
        let collection = collect(that.info)
        that.thirdRatingTotal = collection.sum(product => Number(product.third_rating.value));
      },500)
    },
  },
}
</script>
<style scoped>
thead tr{
  background: #F7F9FC;
  color: #919399;
  font-size: 14px;
}
#pubTable table .listss{
  min-height: 40px !important;
  
}
</style>
<style>

#pubTable .el-textarea__inner{
  /*overflow: hidden !important;*/
  /* max-height: 100px !important;
  height: auto !important; */
}
</style>